<template>
  <div id="nav1_con" >
    <div class="nav" >
      <div class="logo_wrap">
        <h1 class="logo">
          <img class="logo_img" :src="logo" alt="">
        </h1>
        <span>盈融达投资（北京）有限公司</span>
      </div>
      <ul>
<!--        <li class="nav_list" ><router-link to="/home" tag="div"  :class="activeClass == 0 ? 'active nav_list ':''" @click="clickNav($event,0)">首页</router-link></li>-->
<!--        <li class='nav_list' ><router-link to="/aboutUs" tag="div" :class="activeClass == 2 ? 'active nav_list ':''" @click="clickNav($event,2)" >关于我们</router-link></li>-->
<!--        <li class="nav_list" ><router-link to="/companyThought" tag="div"  :class="activeClass == 1 ? 'active nav_list ':''" @click="clickNav($event,1)">公司理念</router-link></li>-->
<!--        <li class='nav_list' ><router-link to="/contactUs" tag="div" :class="activeClass == 3 ? 'active nav_list ':''" @click="clickNav($event,3)">联系我们</router-link></li>-->
        <li class='nav_list' ><router-link to="/"  tag="div" exact>首页</router-link></li>
        <li class='nav_list' ><router-link to="/aboutUs" tag="div" >关于我们</router-link></li>
        <li class="nav_list" ><router-link to="/companyThought" tag="div" >公司理念</router-link></li>
        <li class='nav_list' ><router-link to="/contactUs" tag="div" >联系我们</router-link></li>
      </ul>

    </div>

  </div>
</template>

<script>
  import logo from '../assets/home_logo.png'
  export default {
    name: 'header',
    data () {
      return {
        logo,
      }
    },
    mounted(){

    },
    methods:{

    }
  }
</script>

<style scoped lang='scss'>
  .router-link-active,.active{
    color: #c8ad6d !important;
    border-bottom: 2px solid #c8ad6d!important;
  }
  .active{
    color: #c8ad6d !important;
    border-bottom: 2px solid #c8ad6d!important;
  }
  .active-item{
    color:black;
    height: 5.625rem!important;
  }
  .logo_wrap{
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
  }

  #nav1_con{
    color: black;
    width: 100%;
    height: 5.625rem;
    position: fixed;
    z-index: 2;
    top:0;
    background-color: #fff;

    .nav{
      width: 90%;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin:0 auto;
    h1{
      width: 15%;
    //   height: 100%;
    img{
      width: 100%;
      height: 100%;
    }
  }
  ul{
    display: flex;
    flex-direction: row;
    width: 70%;
    margin-left: 10%;
    justify-content: space-around;
    .nav_list{
      cursor: pointer;
      height: 5.625rem;
      line-height: 5.6rem;
      font-weight:500;
      font-family:PingFang-SC-Medium,PingFang-SC;
      color:black;
      text-align: right;
    }
    .nav_list:hover{
      color: #c8ad6d;
    }
    :last-child{
      margin-right: 0;
    }
  }
  }
  }

  #nav1_con::-webkit-scrollbar {
    display: none;
  }

  /*//移动端布局*/
  @media screen and (max-width:414px) {
    #nav1_con{
      width: 100%;
      background: #000;
      height: 3.5rem;
      display: flex;
      flex-direction: row;
      overflow: auto;
      .nav{
        width: 200%;
        display: flex;
        justify-content: space-around;
        margin:0 auto;
          h1{
            width: 24%;
            height: 100%;
            margin-left: 1rem;
            img{
              width: 100%;
              height: 100%;
            }
           }
      ul{
        color: black;
        height: 3.5rem;
        width: 50rem;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .nav_list{
          color: black;
          font-size: 1rem;
          font-family:PingFang-SC-Medium,PingFang-SC;
          height: 3.5rem;
          line-height: 3.5rem;
          margin-top: 0;
        }
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/header.vue